(function () {
  "use strict";
  var CFG = window.LUMI_CONFIG || {};
  var API = CFG.apiUrl;            // e.g. https://<project>.vercel.app/api/chat
  var AVATAR = CFG.avatar || "";   // Lumi avatar image URL (optional)
  if (!API) { console.warn("[Lumi] no apiUrl configured"); return; }

  var history = [];                // [{role, content}]
  var sending = false;
  var GREETING = "Hi, I am Lumi. I can help you pick the right red light therapy device, answer questions, or check an order. What are you after?";

  // ---------- styles ----------
  var css = "" +
    "#lumi-launcher{position:fixed;right:20px;bottom:20px;width:60px;height:60px;border-radius:50%;background:#000;border:1px solid #2a2a2a;cursor:pointer;z-index:99999;display:flex;align-items:center;justify-content:center;box-shadow:0 6px 24px rgba(0,0,0,.4)}" +
    "#lumi-launcher img{width:60px;height:60px;border-radius:50%;object-fit:cover}" +
    "#lumi-launcher span{color:#ff3b3b;font-size:24px}" +
    "#lumi-panel{position:fixed;right:20px;bottom:90px;width:300px;max-width:calc(100vw - 40px);height:400px;max-height:calc(100vh - 160px);background:#0d0d0d;border:1px solid #2a2a2a;border-radius:16px;z-index:99999;display:none;flex-direction:column;overflow:hidden;font-family:Inter,system-ui,sans-serif}" +
    "#lumi-panel.open{display:flex}" +
    "#lumi-head{padding:14px 16px;background:#000;color:#fff;display:flex;align-items:center;gap:10px;border-bottom:1px solid #1c1c1c;flex-shrink:0}" +
    "#lumi-head img{width:32px;height:32px;border-radius:50%;object-fit:cover}" +
    "#lumi-head b{font-size:15px}" +
    "#lumi-head small{color:#9a9a9a;display:block;font-size:11px}" +
    "#lumi-clear{margin-left:auto;background:none;border:1px solid #2a2a2a;color:#9a9a9a;font-size:12px;cursor:pointer;border-radius:12px;padding:4px 10px}" +
    "#lumi-clear:hover{color:#fff;border-color:#444}" +
    "#lumi-close{margin-left:8px;background:none;border:none;color:#9a9a9a;font-size:20px;cursor:pointer}" +
    "#lumi-msgs{flex:1;min-height:0;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:12px}" +
    ".lumi-row{display:flex;gap:8px;align-items:flex-end}" +
    ".lumi-row.user{flex-direction:row-reverse}" +
    ".lumi-av{width:26px;height:26px;border-radius:50%;object-fit:cover;flex:0 0 26px}" +
    ".lumi-bub{max-width:78%;padding:10px 12px;border-radius:14px;font-size:14px;line-height:1.45;white-space:pre-wrap;word-wrap:break-word}" +
    ".lumi-row.bot .lumi-bub{background:#1a1a1a;color:#eee;border-bottom-left-radius:4px}" +
    ".lumi-row.user .lumi-bub{background:#ff3b3b;color:#fff;border-bottom-right-radius:4px}" +
    ".lumi-dots{display:inline-flex;gap:4px}.lumi-dots i{width:6px;height:6px;border-radius:50%;background:#888;animation:lumiB 1s infinite}.lumi-dots i:nth-child(2){animation-delay:.2s}.lumi-dots i:nth-child(3){animation-delay:.4s}" +
    "@keyframes lumiB{0%,60%,100%{opacity:.3}30%{opacity:1}}" +
    "#lumi-foot{padding:12px;border-top:1px solid #1c1c1c;display:flex;gap:8px;flex-shrink:0;align-items:flex-end}" +
    // font-size MUST be >=16px or iOS Safari auto-zooms the page when the input is focused.
    "#lumi-input{flex:1;min-width:0;box-sizing:border-box;background:#1a1a1a;border:1px solid #2a2a2a;border-radius:16px;color:#fff;padding:9px 12px;font-size:16px;line-height:1.3;font-family:inherit;outline:none;resize:none;max-height:96px;overflow-y:auto}" +
    "#lumi-send{background:#ff3b3b;border:none;color:#fff;border-radius:20px;padding:10px 16px;cursor:pointer;font-weight:600;white-space:nowrap}" +
    "#lumi-send:disabled{opacity:.5;cursor:default}" +
    "#lumi-nudge{position:fixed;right:20px;bottom:90px;z-index:99998;background:#1a1a1a;color:#fff;border:1px solid #2a2a2a;border-radius:16px;padding:9px 14px;font-family:Inter,system-ui,sans-serif;font-size:13px;line-height:1;box-shadow:0 4px 18px rgba(0,0,0,.4);cursor:pointer;white-space:nowrap;display:flex;align-items:center;gap:8px;animation:lumiNudgeIn .4s ease}" +
    "#lumi-nudge.lumi-hidden{display:none}" +
    "#lumi-nudge .lumi-x{opacity:.45;font-size:15px}" +
    "#lumi-nudge .lumi-x:hover{opacity:.9}" +
    "@keyframes lumiNudgeIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}" +
    ".lumi-qa{display:flex;flex-wrap:wrap;gap:6px;padding:2px 12px 2px 14px}" +
    ".lumi-qa button{background:#1a1a1a;border:1px solid #333;color:#eee;border-radius:16px;padding:6px 10px;font-size:12px;cursor:pointer;text-align:center;font-family:inherit;white-space:nowrap}" +
    ".lumi-qa button:hover{border-color:#ff3b3b;color:#fff}" +
    "#lumi-qa-toggle{flex-shrink:0;margin:0 12px 6px;background:#141414;border:1px solid #2a2a2a;color:#9a9a9a;border-radius:14px;padding:6px 12px;font-size:12px;cursor:pointer;font-family:inherit}" +
    "#lumi-qa-toggle:hover{color:#fff;border-color:#444}" +
    "#lumi-qa-toggle.lumi-hidden{display:none}" +
    "@media (max-width:600px){#lumi-panel{top:auto;right:10px;bottom:84px;left:10px;width:auto;max-width:none;height:auto;max-height:55vh;border-radius:16px}}";
  var style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);

  // ---------- DOM ----------
  var launcher = el("div", { id: "lumi-launcher" });
  launcher.innerHTML = AVATAR ? '<img src="' + AVATAR + '" alt="Lumi">' : "<span>&#9679;</span>";
  var panel = el("div", { id: "lumi-panel" });
  panel.innerHTML =
    '<div id="lumi-head">' + (AVATAR ? '<img src="' + AVATAR + '">' : "") +
    '<div><b>Lumi</b><small>Lumovex assistant</small></div>' +
    '<button id="lumi-clear" aria-label="Clear chat" title="Clear chat">Clear</button>' +
    '<button id="lumi-close" aria-label="Close">&times;</button></div>' +
    '<div id="lumi-msgs"></div>' +
    '<div id="lumi-foot"><textarea id="lumi-input" rows="1" placeholder="Ask me anything..." autocomplete="off"></textarea><button id="lumi-send">Send</button></div>';
  var nudge = el("div", { id: "lumi-nudge" });
  nudge.innerHTML = 'Ask me anything <span class="lumi-x" aria-label="Dismiss">&times;</span>';
  document.body.appendChild(launcher);
  document.body.appendChild(nudge);
  document.body.appendChild(panel);

  var msgs = panel.querySelector("#lumi-msgs");
  var input = panel.querySelector("#lumi-input");
  var sendBtn = panel.querySelector("#lumi-send");

  // Quick-action buttons (shown under the greeting, tuck away once chatting).
  var toggleBtn = el("button", { id: "lumi-qa-toggle", class: "lumi-hidden" });
  toggleBtn.textContent = "Quick actions";
  panel.insertBefore(toggleBtn, panel.querySelector("#lumi-foot"));
  toggleBtn.addEventListener("click", function () { renderQuickActions(); });

  var QUICK_ACTIONS = [
    { label: "Explore products", local: function () { botSay("Happy to help you find the right device. What are you mainly looking to support? For example: facial skin and anti-ageing, muscle or joint recovery, full-body sessions, or targeted spot treatment."); } },
    { label: "Track my order", send: "I'd like to track my order." },
    { label: "FAQs & enquiries", local: function () { botSay("Sure - ask me anything about Lumovex: products, shipping, returns, warranty, or how red light therapy works."); } },
    { label: "Contact support", local: function () {
        var bub = addBubble("bot", "");
        bub.innerHTML = 'No problem - I\'ll open an email to our support team for you. If nothing opens, you can email <a href="mailto:hello@lumovex.co.uk" style="color:#ff6b6b">hello@lumovex.co.uk</a> or use the <a href="https://www.lumovex.co.uk/pages/contact" style="color:#ff6b6b">contact page</a>.';
        history.push({ role: "assistant", content: "To contact support, email hello@lumovex.co.uk or visit https://www.lumovex.co.uk/pages/contact" });
        persist();
        var a = document.createElement("a");
        a.href = "mailto:hello@lumovex.co.uk?subject=" + encodeURIComponent("Lumovex support enquiry");
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();
      } },
  ];

  function renderQuickActions() {
    hideQuickActions();
    var row = el("div", { class: "lumi-qa", id: "lumi-qa" });
    QUICK_ACTIONS.forEach(function (a) {
      var b = document.createElement("button");
      b.textContent = a.label;
      b.addEventListener("click", function () {
        hideQuickActions();
        toggleBtn.classList.remove("lumi-hidden");
        if (a.send) sendText(a.send);
        else if (a.local) a.local();
        scroll();
      });
      row.appendChild(b);
    });
    msgs.appendChild(row);
    scroll();
    toggleBtn.classList.add("lumi-hidden");
  }
  function hideQuickActions() {
    var ex = document.getElementById("lumi-qa");
    if (ex) ex.remove();
  }

  var nudgeDismissed = false;
  try { nudgeDismissed = sessionStorage.getItem("lumi_nudge_x") === "1"; } catch (e) {}
  function updateNudge() {
    nudge.classList.toggle("lumi-hidden", panel.classList.contains("open") || nudgeDismissed);
  }
  function isMobile() { return window.innerWidth <= 600; }
  var inputFocused = false;
  // On mobile, when the keyboard opens it shrinks the visual viewport. Anchor the
  // panel to BOTH the top and bottom of the visible area (letting the browser work
  // out the height) so the greeting is never cropped at the top and the Send button
  // is always pinned just above the keyboard. When the keyboard is down we clear the
  // inline styles and fall back to the compact CSS layout. This is more robust than
  // setting a fixed pixel height, which iOS mis-reports mid keyboard-animation.
  // Anchor the panel's BOTTOM to the bottom of the visible area and cap its height,
  // using ONLY visualViewport.height + offsetTop (never window.innerHeight, which iOS
  // reports inconsistently). visualViewport.height always excludes the keyboard, so
  // the panel bottom (and the input/Send button) sits just above the keyboard when
  // open, or above the launcher when closed. Capping the height means the top can
  // never run off the screen, so the greeting is always visible.
  function fitPanelToKeyboard() {
    var vv = window.visualViewport;
    if (!vv || !isMobile() || !panel.classList.contains("open")) return;
    var avail = vv.height;                       // visible height (excludes keyboard)
    var bottomGap = inputFocused ? 8 : 84;       // above keyboard while typing, above launcher otherwise
    var h = Math.min(avail - bottomGap - 8, 440);
    if (h < 160) h = Math.max(avail - bottomGap - 8, 120); // tiny-viewport safety
    panel.style.height = h + "px";
    panel.style.top = (vv.offsetTop + avail - h - bottomGap) + "px";
    panel.style.bottom = "auto";
    panel.style.maxHeight = "none";
    scroll();
  }
  function clearPanelStyles() {
    panel.style.top = panel.style.height = panel.style.bottom = panel.style.maxHeight = "";
  }
  // Lock the background page while the chat is open on mobile. This stops iOS from
  // scrolling the page when the keyboard opens (which is what shifts the fixed panel
  // and crops it). With the page locked, visualViewport.offsetTop stays 0 and the
  // top/bottom anchoring in fitPanelToKeyboard lines up exactly.
  var savedScrollY = 0;
  function lockBody(lock) {
    if (!isMobile()) return;
    var b = document.body;
    if (lock) {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      b.style.position = "fixed";
      b.style.top = -savedScrollY + "px";
      b.style.left = "0";
      b.style.right = "0";
      b.style.width = "100%";
    } else {
      b.style.position = b.style.top = b.style.left = b.style.right = b.style.width = "";
      window.scrollTo(0, savedScrollY);
    }
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", fitPanelToKeyboard);
    window.visualViewport.addEventListener("scroll", fitPanelToKeyboard);
  }
  var suppressGreetingOnce = false;   // set true to open straight into a proactive state (skip the greeting)
  function openPanel() {
    panel.classList.add("open");
    lockBody(true);
    updateNudge();
    if (!msgs.childElementCount && !suppressGreetingOnce) { botSay(GREETING); renderQuickActions(); }
    else if (!document.getElementById("lumi-qa")) { toggleBtn.classList.remove("lumi-hidden"); }
    suppressGreetingOnce = false;
    fitPanelToKeyboard();
    // Only auto-focus on desktop. On mobile, focusing pops the keyboard and
    // scrolls the viewport, which pushes the fixed panel up and crops it.
    if (!isMobile()) input.focus();
  }
  function closePanel() { panel.classList.remove("open"); clearPanelStyles(); lockBody(false); updateNudge(); }

  launcher.addEventListener("click", function () {
    if (panel.classList.contains("open")) closePanel(); else { markInteracted(); openPanel(); }
  });
  panel.querySelector("#lumi-close").addEventListener("click", closePanel);
  panel.querySelector("#lumi-clear").addEventListener("click", function () {
    history = [];
    try { sessionStorage.removeItem("lumi_history"); } catch (e) {}
    msgs.innerHTML = "";
    botSay(GREETING);
    renderQuickActions();
    if (!isMobile()) input.focus();
  });
  nudge.addEventListener("click", function (e) {
    if (e.target && e.target.classList.contains("lumi-x")) {
      nudgeDismissed = true;
      try { sessionStorage.setItem("lumi_nudge_x", "1"); } catch (er) {}
      updateNudge();
      return;
    }
    openPanel();
  });
  updateNudge();
  sendBtn.addEventListener("click", send);
  // Enter sends; Shift+Enter inserts a new line. Grow the box as you type.
  function autoGrow() {
    input.style.height = "auto";
    input.style.height = Math.min(input.scrollHeight, 96) + "px";
  }
  input.addEventListener("input", autoGrow);
  // Re-fit after the keyboard finishes animating (visualViewport resize alone can
  // fire mid-animation with stale values), and again when it closes.
  input.addEventListener("focus", function () {
    inputFocused = true;
    if (isMobile()) { fitPanelToKeyboard(); setTimeout(fitPanelToKeyboard, 200); setTimeout(fitPanelToKeyboard, 500); }
  });
  input.addEventListener("blur", function () {
    inputFocused = false;
    if (isMobile()) { fitPanelToKeyboard(); setTimeout(fitPanelToKeyboard, 150); }
  });
  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); }
  });

  // Session transcript is restored at the very end (after the card renderer is wired).
  function sessionRestore() {
    try {
      var saved = sessionStorage.getItem("lumi_history");
      if (!saved) return;
      history = JSON.parse(saved);
      history.forEach(function (m) {
        if (m.card) { renderCard(m.card); }
        else if (m.role === "user") { addBubble("user", m.content); }
        else { var b = addBubble("bot", ""); b.innerHTML = linkify(m.content); }
      });
    } catch (e) {}
  }

  // ---------- helpers ----------
  function el(tag, attrs) { var n = document.createElement(tag); if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]); return n; }
  function scroll() { msgs.scrollTop = msgs.scrollHeight; }
  function persist() { try { sessionStorage.setItem("lumi_history", JSON.stringify(history.slice(-20))); } catch (e) {} }

  function addBubble(who, text) {
    var row = el("div", { class: "lumi-row " + who });
    if (who === "bot" && AVATAR) { var av = el("img", { class: "lumi-av", src: AVATAR }); row.appendChild(av); }
    var bub = el("div", { class: "lumi-bub" });
    bub.textContent = text || "";
    row.appendChild(bub);
    msgs.appendChild(row);
    scroll();
    return bub;
  }
  function botSay(text) { history.push({ role: "assistant", content: text }); persist(); return addBubble("bot", text); }

  function showTyping() {
    var row = el("div", { class: "lumi-row bot", id: "lumi-typing" });
    if (AVATAR) row.appendChild(el("img", { class: "lumi-av", src: AVATAR }));
    var bub = el("div", { class: "lumi-bub" });
    bub.innerHTML = '<span class="lumi-dots"><i></i><i></i><i></i></span>';
    row.appendChild(bub);
    msgs.appendChild(row);
    scroll();
    return row;
  }

  function sendText(text) {
    text = (text || "").trim();
    if (!text || sending) return;
    markInteracted();
    hideQuickActions();
    toggleBtn.classList.remove("lumi-hidden");
    addBubble("user", text);
    history.push({ role: "user", content: text });
    persist();
    stream(text);
  }
  function send() { var t = input.value; input.value = ""; autoGrow(); sendText(t); }

  function stream(text) {
    sending = true; sendBtn.disabled = true;
    var typing = showTyping();
    var bub = null;            // becomes the streaming bot bubble on first text
    var acc = "";

    fetch(API, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages: history.filter(function (m) { return m.content; }).slice(-20) }),
    }).then(function (resp) {
      if (!resp.ok || !resp.body) throw new Error("bad response " + resp.status);
      var reader = resp.body.getReader();
      var dec = new TextDecoder();
      var buf = "";
      function pump() {
        return reader.read().then(function (r) {
          if (r.done) { finish(); return; }
          buf += dec.decode(r.value, { stream: true });
          var parts = buf.split("\n\n");
          buf = parts.pop();
          parts.forEach(function (p) {
            var line = p.replace(/^data: /, "").trim();
            if (!line) return;
            var ev; try { ev = JSON.parse(line); } catch (e) { return; }
            handleEvent(ev);
          });
          return pump();
        });
      }
      function handleEvent(ev) {
        if (ev.type === "text") {
          if (typing) { typing.remove(); typing = null; }
          if (!bub) bub = addBubble("bot", "");
          acc += ev.value; bub.textContent = acc; scroll();
        } else if (ev.type === "card") {
          if (typing) { typing.remove(); typing = null; }
          renderCard(ev.value);
          history.push({ role: "assistant", card: ev.value });
          persist();
        } else if (ev.type === "error") {
          if (typing) { typing.remove(); typing = null; }
          addBubble("bot", ev.value);
        }
      }
      function finish() {
        if (typing) { typing.remove(); typing = null; }
        if (bub && acc) bub.innerHTML = linkify(acc);
        if (acc) { history.push({ role: "assistant", content: acc }); persist(); }
        sending = false; sendBtn.disabled = false;
        if (!isMobile()) input.focus();
      }
      return pump();
    }).catch(function () {
      if (typing) typing.remove();
      addBubble("bot", "Sorry, I could not connect just now. Please try again.");
      sending = false; sendBtn.disabled = false;
    });
  }

  // append card styles
  var cardCss = document.createElement("style");
  cardCss.textContent =
    ".lumi-card{background:#161616;border:1px solid #2a2a2a;border-radius:12px;padding:10px;display:flex;gap:10px;align-items:center;max-width:90%}" +
    ".lumi-card img{width:56px;height:56px;border-radius:8px;object-fit:cover;flex:0 0 56px}" +
    ".lumi-card .ttl{color:#fff;font-size:13px;font-weight:600}" +
    ".lumi-card .pr{color:#ff6b6b;font-size:13px}" +
    ".lumi-card .pr s{color:#888;margin-left:6px;font-weight:400}" +
    ".lumi-card .acts{display:flex;gap:6px;margin-top:6px}" +
    ".lumi-card button{background:#ff3b3b;border:none;color:#fff;border-radius:14px;padding:5px 10px;font-size:12px;cursor:pointer}" +
    ".lumi-card a{color:#bbb;font-size:12px;align-self:center;text-decoration:none}";
  document.head.appendChild(cardCss);

  window.__lumiRenderCard = function (card, ctx) {
    var row = document.createElement("div");
    row.className = "lumi-row bot";
    if (ctx.AVATAR) { var av = document.createElement("img"); av.className = "lumi-av"; av.src = ctx.AVATAR; row.appendChild(av); }
    var c = document.createElement("div");
    c.className = "lumi-card";
    var img = card.image ? '<img src="' + card.image + '" alt="">' : "";
    var price = '<span class="pr">' + (card.price || "") + (card.compareAt ? " <s>" + card.compareAt + "</s>" : "") + "</span>";
    c.innerHTML = img +
      '<div><div class="ttl">' + esc(card.title) + "</div>" + price +
      '<div class="acts"><button class="lumi-add">Add to cart</button>' +
      '<a href="' + card.productUrl + '">View</a></div></div>';
    row.appendChild(c);
    ctx.msgs.appendChild(row);
    ctx.scroll();

    c.querySelector(".lumi-add").addEventListener("click", function () {
      var btn = this; btn.disabled = true; btn.textContent = "Adding...";
      assistantAdding = Date.now();
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: Number(card.variantId), quantity: card.qty || 1 }] }),
      }).then(function (r) {
        if (!r.ok) throw new Error("add failed");
        btn.textContent = "Added ✓";
        refreshCartCount();
        ctx.addBubble("bot", "Added to your cart. You can keep shopping or head to checkout.");
        var go = document.createElement("a");
        go.href = "/cart"; go.textContent = "Go to cart"; go.target = "_top";
        go.style.cssText = "display:inline-block;margin-top:4px;color:#ff6b6b;font-size:13px";
        ctx.msgs.lastChild.querySelector(".lumi-bub").appendChild(document.createElement("br"));
        ctx.msgs.lastChild.querySelector(".lumi-bub").appendChild(go);
        ctx.scroll();
      }).catch(function () {
        btn.disabled = false; btn.textContent = "Add to cart";
        ctx.addBubble("bot", "Sorry, I could not add that. Please try the product page.");
      });
    });
  };

  function esc(s) { var d = document.createElement("div"); d.textContent = s || ""; return d.innerHTML; }
  function renderCard(card) { window.__lumiRenderCard(card, { msgs: msgs, addBubble: addBubble, scroll: scroll, AVATAR: AVATAR }); }

  // Escape, then turn markdown links and bare URLs into clickable anchors.
  function linkify(text) {
    var html = esc(text);
    html = html.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, function (m, label, url) {
      return '<a href="' + url + '" style="color:#ff6b6b;text-decoration:underline">' + label + '</a>';
    });
    html = html.replace(/(^|[^"'>=])(https?:\/\/[^\s<]+)/g, function (m, pre, url) {
      return pre + '<a href="' + url + '" style="color:#ff6b6b;text-decoration:underline">' + url + '</a>';
    });
    return html;
  }

  // Refresh the theme's header cart count after an add (so the trolley updates).
  function refreshCartCount() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        document.querySelectorAll(".header__cart-count, [data-cart-count], .cart-count, .cart-count-bubble").forEach(function (el) {
          el.textContent = n;
          el.setAttribute("data-cart-count", n);
          el.hidden = false;
          el.style.display = "";
          el.classList.remove("hidden", "is-empty", "count-is-empty");
        });
        try { document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true })); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cart } })); } catch (e) {}
      })
      .catch(function () {});
  }

  // ============ Phase 1: proactive add-to-cart bundle upsell (rule-based, no GPT) ============
  var assistantAdding = 0;      // timestamp of an assistant-card-initiated add
  var internalCartOp = false;   // true while WE drive cart writes (upgrade) so the interceptor ignores them

  // Approved single -> bundle upsell map (real Shopify handles + live bundle variant IDs).
  // Mask+Neck, Portable Panel and Wrist Strap are intentionally UNMAPPED (no honest kit upsell exists).
  var BUNDLE_MAP = {
    "lumovex-spectrum-pro-mask": { bundleHandle: "complete-face-kit", bundleVariantId: 53724140339546,
      message: "Nice choice. If you're building a full facial routine, you may want to look at the Complete Face Kit. It includes the Face Mask + Sculpt Wand and saves £10.99 compared with buying separately.",
      upgrade: "Upgrade to Kit", view: "View Complete Face Kit", keep: "Keep Mask Only" },
    "lumovex-sculpt-wand": { bundleHandle: "complete-face-kit", bundleVariantId: 53724140339546,
      message: "The Sculpt Wand is great for targeted areas. Many customers pair it with the Face Mask for a fuller face routine. Want to see the Complete Face Kit?",
      upgrade: "Upgrade to Kit", view: "View Complete Face Kit", keep: "Keep Wand Only" },
    "lumovex-red-light-therapy-belt": { bundleHandle: "recovery-kit", bundleVariantId: 53724137783642,
      message: "Want a fuller recovery setup? The Recovery Kit includes the Recovery Belt + Total Recovery Mat and saves £21.99 versus buying separately.",
      upgrade: "Upgrade to Kit", view: "View Recovery Kit", keep: "No Thanks" },
    "lumovex-total-recovery-mat": { bundleHandle: "recovery-kit", bundleVariantId: 53724137783642,
      message: "A lot of customers use the Recovery Mat with the Recovery Belt for more targeted recovery. The Recovery Kit includes both and saves £21.99.",
      upgrade: "Upgrade Basket", view: "View Recovery Kit", keep: "No Thanks" },
    "lumovex-pro-panel-540": { bundleHandle: "home-clinic", bundleVariantId: 53724139159898,
      message: "Building a fuller home red light setup? The Home Clinic bundle includes the Face Mask + Pro Panel 540 + Recovery Belt and saves £54.98.",
      upgrade: "Upgrade to Home Clinic", view: "View Home Clinic", keep: "No Thanks" }
  };

  var pStyle = document.createElement("style");
  pStyle.textContent =
    "#lumi-proactive{position:fixed;right:20px;bottom:90px;z-index:2147483000;max-width:260px;background:#1a1a1a;color:#fff;border:1px solid #2a2a2a;border-radius:16px;padding:12px 14px;font-family:Inter,system-ui,sans-serif;font-size:13px;line-height:1.4;box-shadow:0 4px 18px rgba(0,0,0,.45);animation:lumiNudgeIn .4s ease;cursor:pointer;touch-action:manipulation;-webkit-tap-highlight-color:transparent}" +
    "#lumi-proactive .lumi-pmsg{margin-bottom:8px}" +
    "#lumi-proactive .lumi-pacts{display:flex;gap:8px;align-items:center}" +
    "#lumi-proactive .lumi-pshow{display:inline-block;background:#ff3b3b;color:#fff;border-radius:14px;padding:7px 14px;font-size:12px;font-weight:600}" +
    "#lumi-proactive .lumi-px{margin-left:auto;opacity:.6;font-size:18px;padding:2px 8px;touch-action:manipulation}" +
    "@media (max-width:600px){#lumi-proactive{right:10px;left:10px;max-width:none;bottom:84px}}";
  document.head.appendChild(pStyle);

  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function sessionId() { var s = ssGet("lumi_session_id"); if (!s) { s = "lumi_" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); ssSet("lumi_session_id", s); } return s; }
  function markInteracted() { ssSet("lumi_interacted", "1"); }

  // central proactive gate
  function canShowProactive(triggerKey) {
    if (ssGet("lumi_proactive_dismissed") === "1") return false;        // dismissal kills proactive for the session
    var fired; try { fired = JSON.parse(ssGet("lumi_triggers_fired") || "[]"); } catch (e) { fired = []; }
    if (triggerKey && fired.indexOf(triggerKey) >= 0) return false;     // never repeat the same trigger
    if (ssGet("lumi_proactive_shown") === "1" && ssGet("lumi_interacted") !== "1") return false; // one per session unless they interact
    return true;
  }
  function recordShown(triggerKey) {
    ssSet("lumi_proactive_shown", "1");
    ssSet("lumi_interacted", "0");
    var fired; try { fired = JSON.parse(ssGet("lumi_triggers_fired") || "[]"); } catch (e) { fired = []; }
    if (triggerKey && fired.indexOf(triggerKey) < 0) { fired.push(triggerKey); ssSet("lumi_triggers_fired", JSON.stringify(fired)); }
  }
  function dismissProactive() { ssSet("lumi_proactive_dismissed", "1"); }

  function money(pence) { if (pence == null || pence === "") return ""; var n = Number(pence); if (!isFinite(n)) return ""; return "£" + (n / 100).toFixed(2); }
  function fixImg(u) { if (!u) return ""; return u.indexOf("//") === 0 ? "https:" + u : u; }
  function getCart() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).catch(function () { return null; }); }

  // analytics scaffold: fires to dataLayer + Klaviyo + a DOM event (reporting wired later)
  function lumiTrack(event, props) {
    var p = { page_url: location.href, session_id: sessionId(), device_type: isMobile() ? "mobile" : "desktop", timestamp: new Date().toISOString() };
    if (props) for (var k in props) p[k] = props[k];
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: "lumi_" + event }, p)); } catch (e) {}
    try { if (window.klaviyo && window.klaviyo.push) window.klaviyo.push(["track", "Lumi " + event, p]); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent("lumi:track", { detail: { event: event, props: p } })); } catch (e) {}
    try { if (window.console && console.debug) console.debug("[Lumi]", event, p); } catch (e) {}
  }

  // ---- cart-add interception (theme-agnostic: fetch + XHR), debounced ----
  function matchesCartAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(url || ""); }
  var pendingAdd = null, addTimer = null;
  function onCartAdd(data) {
    if (internalCartOp) return;                          // ignore our own upgrade-driven cart writes
    var items = [];
    if (data && Array.isArray(data.items)) items = data.items;
    else if (data && (data.id || data.variant_id || data.handle)) items = [data];
    if (!items.length) return;
    var primary = null;
    for (var i = 0; i < items.length; i++) { if (items[i] && items[i].handle && BUNDLE_MAP[items[i].handle]) { primary = items[i]; break; } }
    if (!primary) primary = items[0];
    pendingAdd = { item: primary, fromAssistant: (Date.now() - assistantAdding < 4000) };
    if (addTimer) clearTimeout(addTimer);
    addTimer = setTimeout(processPendingAdd, 800);       // debounce rapid cart updates
  }
  function processPendingAdd() {
    var rec = pendingAdd; pendingAdd = null;
    if (!rec || !rec.item) return;
    var it = rec.item, handle = it.handle, variantId = it.variant_id || it.id;
    if (rec.fromAssistant) {
      lumiTrack("add_to_cart_from_assistant", { trigger_type: "assistant_card", original_product_handle: handle, original_variant_id: variantId });
      return;                                            // already engaged in the assistant; no proactive prompt
    }
    var map = handle ? BUNDLE_MAP[handle] : null;
    if (!map) return;                                    // unmapped product -> do nothing
    var triggerKey = "addtocart:" + handle;
    if (!canShowProactive(triggerKey)) return;
    triggerUpsell({ handle: handle, variantId: variantId, productId: it.product_id, map: map, triggerKey: triggerKey });
  }
  function installCartIntercept() {
    var of = window.fetch;
    if (of && !of.__lumiWrapped) {
      var wf = function (input) {
        var url = (typeof input === "string") ? input : (input && input.url) || "";
        var pr = of.apply(this, arguments);
        if (matchesCartAdd(url)) { pr.then(function (res) { try { res.clone().json().then(onCartAdd).catch(function () {}); } catch (e) {} }).catch(function () {}); }
        return pr;
      };
      wf.__lumiWrapped = true; window.fetch = wf;
    }
    var XO = window.XMLHttpRequest;
    if (XO && XO.prototype && !XO.prototype.__lumiWrapped) {
      var oOpen = XO.prototype.open, oSend = XO.prototype.send;
      XO.prototype.open = function (m, url) { this.__lumiUrl = url; return oOpen.apply(this, arguments); };
      XO.prototype.send = function () {
        var xhr = this;
        if (matchesCartAdd(xhr.__lumiUrl)) { xhr.addEventListener("load", function () { try { onCartAdd(JSON.parse(xhr.responseText)); } catch (e) {} }); }
        return oSend.apply(this, arguments);
      };
      XO.prototype.__lumiWrapped = true;
    }
  }

  // ---- upsell rendering ----
  function triggerUpsell(u) {
    Promise.all([
      fetch("/products/" + u.map.bundleHandle + ".js").then(function (r) { return r.json(); }).catch(function () { return null; }),
      getCart()
    ]).then(function (res) {
      var prod = res[0], cart = res[1];
      if (!prod) return;                                 // can't build the card -> bail quietly
      var v = (prod.variants && prod.variants[0]) || {};
      var card = {
        title: prod.title, price: money(v.price),
        compareAt: v.compare_at_price ? money(v.compare_at_price) : "",
        image: fixImg(prod.featured_image || (prod.images && prod.images[0]) || ""),
        productUrl: "/products/" + prod.handle, variantId: (v.id || u.map.bundleVariantId)
      };
      recordShown(u.triggerKey);
      lumiTrack("proactive_bundle_upsell_shown", {
        trigger_type: "add_to_cart", original_product_handle: u.handle, original_variant_id: u.variantId,
        recommended_bundle_handle: u.map.bundleHandle, recommended_bundle_variant_id: u.map.bundleVariantId,
        cart_value: cart ? money(cart.total_price) : ""
      });
      var upsell = { origHandle: u.handle, origVariantId: u.variantId, map: u.map, card: card };
      if (isMobile()) showProactiveBubble(upsell);       // mobile: bubble first
      else openPanelToUpsell(upsell);                    // desktop: strong intent -> open the panel directly
    }).catch(function () {});
  }

  function showProactiveBubble(upsell) {
    removeProactiveBubble();
    try { nudge.classList.add("lumi-hidden"); } catch (e) {}
    var b = el("div", { id: "lumi-proactive", role: "button", tabindex: "0" });
    b.innerHTML = '<div class="lumi-pmsg">Nice pick. Want to see a bundle that saves you money?</div>' +
      '<div class="lumi-pacts"><span class="lumi-pshow">Show me</span><span class="lumi-px" aria-label="Dismiss">&times;</span></div>';
    document.body.appendChild(b);
    var opened = false;
    // The WHOLE bubble opens the upsell (big tap target). The X stops propagation and dismisses.
    function openIt(e) { if (e) { e.preventDefault(); e.stopPropagation(); } if (opened) return; opened = true; markInteracted(); removeProactiveBubble(); openPanelToUpsell(upsell); }
    function dismissIt(e) { if (e) { e.preventDefault(); e.stopPropagation(); } removeProactiveBubble(); dismissProactive(); updateNudge(); lumiTrack("proactive_bundle_upsell_dismissed", { trigger_type: "add_to_cart", source: "bubble", recommended_bundle_handle: upsell.map.bundleHandle }); }
    b.addEventListener("click", openIt);
    b.querySelector(".lumi-px").addEventListener("click", dismissIt);
  }
  function removeProactiveBubble() { var x = document.getElementById("lumi-proactive"); if (x) x.remove(); }

  function openPanelToUpsell(upsell) {
    removeProactiveBubble();
    suppressGreetingOnce = true;
    openPanel();
    botSay(upsell.map.message);
    renderCard(upsell.card);
    history.push({ role: "assistant", card: upsell.card }); persist();
    renderUpsellButtons(upsell);
  }

  function renderUpsellButtons(upsell) {
    removeUpsellButtons();
    var row = el("div", { class: "lumi-qa", id: "lumi-upsell-acts" });
    var defs = [
      { label: upsell.map.upgrade, act: function () { doUpgrade(upsell); } },
      { label: upsell.map.view, act: function () {
          lumiTrack("proactive_bundle_upsell_view_clicked", { trigger_type: "add_to_cart", recommended_bundle_handle: upsell.map.bundleHandle, recommended_bundle_variant_id: upsell.map.bundleVariantId });
          location.href = upsell.card.productUrl;
        } },
      { label: upsell.map.keep, act: function () {
          removeUpsellButtons(); dismissProactive();
          lumiTrack("proactive_bundle_upsell_dismissed", { trigger_type: "add_to_cart", source: "keep", recommended_bundle_handle: upsell.map.bundleHandle });
          botSay("No problem - I'll leave your cart as it is. Shout if you need help choosing.");
        } }
    ];
    defs.forEach(function (d) {
      var btn = document.createElement("button");
      btn.textContent = d.label;
      btn.addEventListener("click", function () { markInteracted(); d.act(); });
      row.appendChild(btn);
    });
    msgs.appendChild(row); scroll();
  }
  function removeUpsellButtons() { var x = document.getElementById("lumi-upsell-acts"); if (x) x.remove(); }

  function appendCartLink() {
    var bub = msgs.querySelector(".lumi-row.bot:last-child .lumi-bub"); if (!bub) return;
    var go = document.createElement("a"); go.href = "/cart"; go.textContent = "Go to cart"; go.target = "_top";
    go.style.cssText = "display:inline-block;margin-top:4px;color:#ff6b6b;font-size:13px";
    bub.appendChild(document.createElement("br")); bub.appendChild(go); scroll();
  }

  // Upgrade: add the bundle (duplicate-guarded), remove the single line via /cart/change.js, fallback if removal isn't confirmed.
  function doUpgrade(upsell) {
    removeUpsellButtons();
    lumiTrack("proactive_bundle_upsell_upgrade_clicked", {
      trigger_type: "add_to_cart", original_product_handle: upsell.origHandle, original_variant_id: upsell.origVariantId,
      recommended_bundle_handle: upsell.map.bundleHandle, recommended_bundle_variant_id: upsell.map.bundleVariantId
    });
    var working = addBubble("bot", "Updating your cart...");
    var bundleVid = Number(upsell.card.variantId || upsell.map.bundleVariantId);
    internalCartOp = true;
    getCart().then(function (cart) {
      var bundleInCart = cart && cart.items && cart.items.some(function (li) { return Number(li.variant_id) === bundleVid; });
      var addP = bundleInCart ? Promise.resolve(true)
        : fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: bundleVid, quantity: 1 }] }) }).then(function (r) { return r.ok; });
      return addP.then(function (added) {
        if (!added) throw new Error("add-failed");
        return getCart().then(function (c2) {
          var line = c2 && c2.items && c2.items.filter(function (li) { return Number(li.variant_id) === Number(upsell.origVariantId); })[0];
          if (!line) return { removed: true };           // single already gone -> treat as clean
          return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: line.key, quantity: 0 }) })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (c3) {
              var still = c3 && c3.items && c3.items.some(function (li) { return Number(li.variant_id) === Number(upsell.origVariantId); });
              return { removed: !!c3 && !still };
            });
        });
      });
    }).then(function (result) {
      internalCartOp = false;
      try { fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { lumi_assist: "addtocart_" + upsell.origHandle + "_to_" + upsell.map.bundleHandle } }) }); } catch (e) {}
      refreshCartCount();
      working.remove();
      if (result && result.removed) {
        botSay("Done. I've swapped that into the " + upsell.card.title + " for you.");
        appendCartLink();
        lumiTrack("proactive_bundle_upsell_upgrade_success", { trigger_type: "add_to_cart", original_product_handle: upsell.origHandle, recommended_bundle_handle: upsell.map.bundleHandle });
      } else {
        botSay("I've added the " + upsell.card.title + " to your cart. You may want to remove the single product before checkout.");
        appendCartLink();
        lumiTrack("proactive_bundle_upsell_upgrade_failed", { trigger_type: "add_to_cart", reason: "removal_unconfirmed", original_product_handle: upsell.origHandle, recommended_bundle_handle: upsell.map.bundleHandle });
      }
    }).catch(function () {
      internalCartOp = false;
      working.remove();
      botSay("Sorry, I couldn't update your cart automatically. Please try from the cart page.");
      lumiTrack("proactive_bundle_upsell_upgrade_failed", { trigger_type: "add_to_cart", reason: "add_failed", original_product_handle: upsell.origHandle, recommended_bundle_handle: upsell.map.bundleHandle });
    });
  }

  installCartIntercept();
  sessionRestore();
})();
